import {
  HostedIntegrationListPage,
  HostedIntegrationListPageProps,
} from "~/pages/integrations/hosted-integrations";

const HostedIntegrationListEntryPage = ({
  scope,
}: HostedIntegrationListPageProps) => {
  return <HostedIntegrationListPage {...{ scope }} />;
};

export default HostedIntegrationListEntryPage;
